import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import io from 'socket.io-client';

import RbFirmwareModalComponent from '../components/rb-firmware-modal/rb-firmware-modal.jsx';
import {updateVersion} from '../reducers/connection';
import {closeFirmware, closeUploading, openUploadFailure, openUploading, openUploadSuccess} from '../reducers/modals';
import {updateStatus} from '../reducers/connection';
import {closeConnectedMenu} from '../reducers/menus';
import {config} from '../config';

class RbFirmwareModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel',
            'handleKeyPress',
            'handleOk',
            'handleChangeBoard'
        ]);
        this.socket = io(config.socketUrl);
        this.state = {
            selectValueBoard: 'k2',
            mainBoard: [
                {
                    k: 'k2',
                    v: 'Q-scout'
                },
                {
                    k: 'k1',
                    v: 'Qoopers'
                }

            ],
            Okdisabled: false
        };
    }

    handleCancel (e) {
        e.stopPropagation();
        this.props.onClose();
        this.props.onRequestCloseConnection();
    }
    handleKeyPress (event) {
        if (event.key === 'Enter') this.handleOk();
    }
    handleOk (e) {
        e.stopPropagation();
        let board = '';
        if (this.state.selectValueBoard === 'k1') {
            board = 'mega';
        } else {
            board = 'uno';
        }
        const data = {
            board,
            url: config.getHexUrl(this.state.selectValueBoard)
        };
        this.handleCancel(e);
        this.props.onOpenUploadingModal();
        this.socket.emit('resetFirmware', data, status => {
            if (status) {
                this.props.onCloseUploadingModal();
                this.props.onOpenUploadSuccessModal();
            } else {
                this.props.onCloseUploadingModal();
                this.props.onOpenUploadFailureModal();
            }
            this.props.onUpdateStatus(false);
        });
    }
    handleChangeBoard (e) {
        this.setState({
            selectValueBoard: e.target.value
        });
    }
    render () {
        return (
            <RbFirmwareModalComponent
                Okdisabled={this.state.Okdisabled}
                mainBoard={this.state.mainBoard}
                onCancel={this.handleCancel}
                onChangeBoard={this.handleChangeBoard}
                onKeyPress={this.handleKeyPress}
                onOk={this.handleOk}
                
            />
        );
    }
}

RbFirmwareModal.propTypes = {
    onClose: PropTypes.func,
    onCloseUploadingModal: PropTypes.func.isRequired,
    onOpenUploadFailureModal: PropTypes.func.isRequired,
    onOpenUploadSuccessModal: PropTypes.func.isRequired,
    onOpenUploadingModal: PropTypes.func.isRequired,
    onRequestCloseConnection: PropTypes.func.isRequired,
    onUpdateStatus: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeFirmware());
    },
    onCloseUploadingModal: () => {
        dispatch(closeUploading());
    },
    onOpenUploadSuccessModal: () => {
        dispatch(openUploadSuccess());
    },
    onOpenUploadFailureModal: () => {
        dispatch(openUploadFailure());
    },
    onOpenUploadingModal: () => {
        dispatch(openUploading());
    },
    onUpdateStatus: status => {
        dispatch(updateStatus(status));
    },
    onRequestCloseConnection: () => dispatch(closeConnectedMenu()),
    onUpdateVersion: version => {
        dispatch(updateVersion(version));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RbFirmwareModal);
